import React from 'react';
import { Route } from 'react-router-dom';
import DeliveryReport from './DeliveryReport';

const routes = () => [
  <Route path="/delivery-report" exact component={DeliveryReport} key="/delivery-report" />,
].map(route => route);

export default routes;
